exports.components = {
  "component---src-pages-health-tsx": () => import("./../../../src/pages/health.tsx" /* webpackChunkName: "component---src-pages-health-tsx" */),
  "component---src-pages-suburb-profiles-tsx": () => import("./../../../src/pages/suburb-profiles.tsx" /* webpackChunkName: "component---src-pages-suburb-profiles-tsx" */),
  "component---src-templates-city-pages-tsx": () => import("./../../../src/templates/city-pages.tsx" /* webpackChunkName: "component---src-templates-city-pages-tsx" */)
}

